import { useScrollReveal } from '../../../hooks/useScrollReveal';

const topics = [
  {
    icon: 'ri-macbook-line',
    title: 'Apple製品・Mac活用',
    desc: 'Mac歴15年の経験から、Macと周辺機器の実践的な使い方をお届けします。日々の作業を快適にするヒントも。',
    link: 'https://number84log.com/macbook-setting/',
  },
  {
    icon: 'ri-device-line',
    title: 'ガジェットレビュー',
    desc: '実際に手にして使った経験をもとに、正直な感想をお伝えします。良い点も気になる点も、包み隠さず。',
    link: 'https://number84log.com/?s=レビュー',
  },
  {
    icon: 'ri-computer-line',
    title: 'デスクアイテム',
    desc: '心地よい作業環境をつくるアイテムをご紹介。機能性と美しさを兼ね備えたものを厳選しています。',
    link: 'https://number84log.com/desktour/',
  },
  {
    icon: 'ri-home-wifi-line',
    title: 'スマートホーム',
    desc: '暮らしを快適にするスマートデバイスの活用法。Apple製品との連携についてもご紹介しています。',
    link: 'https://number84log.com/category/smarthome/',
  },
];

export default function TopicsSection() {
  const ref = useScrollReveal();

  return (
    <section className="w-full bg-[#FAFAFA] py-12 px-6">
      <div ref={ref} className="section-reveal max-w-2xl mx-auto">
        <p className="text-xs font-medium text-[#9A9A9A] tracking-[0.2em] uppercase mb-3">Topics</p>
        <div className="w-10 h-px bg-[#E0E0E0] mb-3" />
        <div className="text-xl md:text-2xl font-bold text-[#1A1A1A] tracking-wide mb-10">発信テーマ</div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {topics.map((topic) => {
            const Tag = topic.link ? 'a' : 'div';
            return (
              <Tag
                key={topic.title}
                {...(topic.link
                  ? { href: topic.link, target: '_blank', rel: 'noopener noreferrer' }
                  : {})}
                className="bg-white border border-[#EEEEEE] rounded-xl p-6 hover:bg-[#F8F8F8] transition-colors duration-200 cursor-pointer"
              >
                <div className="w-9 h-9 flex items-center justify-center mb-4">
                  <i className={`${topic.icon} text-[22px] text-[#4A4A4A]`} />
                </div>
                <h3 className="text-[15px] font-bold text-[#1A1A1A] mb-2 tracking-wide">{topic.title}</h3>
                <p className="text-[13px] leading-relaxed text-[#6B6B6B]">{topic.desc}</p>
              </Tag>
            );
          })}
        </div>
      </div>
    </section>
  );
}